import { Button } from "web/components"

import { useLayouts } from "web/hooks/data"

import { sortByKey } from "web/services/helpers"

import useShowLayoutModal from "./useShowLayoutModal"

export default function ListLayouts({ subjectType, topicId }) {
  const layouts = useLayouts({ subjectType, topicId })
  const showLayoutModal = useShowLayoutModal()

  const hasLayouts = layouts.length !== 0

  async function handleAddLayout() {
    const newLayout = await layouts.addLayout()
    if (newLayout) showLayoutModal(newLayout, subjectType)
  }

  async function handleEditLayout(layout) {
    showLayoutModal(layout, subjectType)
  }

  return (
    <div>
      <div className="mb-2.5">
        <Button onClick={handleAddLayout}>Add Layout</Button>
      </div>
      {hasLayouts && (
        <div className="layout-list grid auto-rows-auto gap-y-2.5">
          {sortByKey(layouts, "name").map((layout) => (
            <div
              key={layout.name}
              className="grid h-10 items-center rounded-md bg-white px-2.5 py-0 shadow"
            >
              <span
                className="cursor-pointer text-primary-4 hover:text-feature-6"
                onClick={() => handleEditLayout(layout)}
              >
                {layout.name}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
